// src/components/WhatsAppChat.js
import React from 'react';
import { Fab, Zoom, Tooltip } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { PHONE_RAW } from '../data/Contact';

const WhatsAppChat = () => {
  const phoneNumber = PHONE_RAW; 
  const message = 'Hi! I am interested in your services.';

  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <Zoom in={true} timeout={300}>
      <Tooltip title="Chat with us" arrow>
        <Fab
          color="success"
          size="medium"
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            position: 'fixed',
            bottom: 24,
            right: 24,
            zIndex: 1300,
            boxShadow: 3,
            '&:hover': {
              backgroundColor: '#25D366',
            },
          }}
          aria-label="Chat on WhatsApp"
        >
          <WhatsAppIcon />
        </Fab>
      </Tooltip>
    </Zoom>
  );
};

export default WhatsAppChat;
